module.exports = __webpack_public_path__ + "static/media/service-details-promo2.015080b1.png";